import React from 'react'
import { Item } from './styled'

export default props => {
  const { url, exact, heading, active } = props
  const to = url || '/'
  return (
    <Item>
      <Item.Link to={to} exact={exact} className={active ? 'active' : ''}>
        <Item.Inner>
          <Item.Heading>{heading}</Item.Heading>
        </Item.Inner>
      </Item.Link>
    </Item>
  )
}
